"use client";

import { useEffect } from "react";
import { registerPushTapListenerEarly } from "@/lib/push-notifications/init";

function isMobileCapacitor(): boolean {
  if (typeof window === "undefined") return false;
  const Capacitor = (window as unknown as { Capacitor?: { getPlatform?: () => string } }).Capacitor;
  if (!Capacitor) return false;
  const platform = Capacitor.getPlatform?.() || "web";
  return platform === "ios" || platform === "android";
}

/**
 * Registers the push tap listener as early as possible (root layout).
 * This captures notification taps on cold start before the user reaches the app layout,
 * ensuring deep links work when opening the app from a notification.
 * Uses a short delay so the app/router can initialize - Capacitor fires the cached
 * tap event when the listener is added; deferring slightly ensures we can handle it.
 */
export function EarlyPushTapHandler() {
  useEffect(() => {
    if (!isMobileCapacitor()) return;
    const timer = setTimeout(() => {
      registerPushTapListenerEarly().catch(() => {});
    }, 100);
    return () => clearTimeout(timer);
  }, []);
  return null;
}
